import { useQuery } from '@tanstack/react-query';
import { useDebounce } from 'use-debounce';
import { partialParkingOptions } from '../../constants/partialParkings';
import { isAxiosTimeout } from '../../utils/isAxiosTimeout';
const FETCHING_DELAYED_MILLISECONDS = 200;
export function usePartialParkings(filter) {
    const { data, isLoading, isFetching, isSuccess, error } = useQuery(partialParkingOptions.get(filter));
    const [fetchingPartialParkingsDelayed] = useDebounce(isFetching, FETCHING_DELAYED_MILLISECONDS);
    return {
        partialParkings: data ?? [],
        loadingPartialParkings: isLoading,
        fetchingPartialParkingsDelayed,
        isSuccess,
        partialParkingsTimedOut: isAxiosTimeout(error),
    };
}
